import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Divider, Typography, AppBar, Paper } from "@material-ui/core";
import ThemeTablen from "../Table/ThemeTablen.jsx";
import CommonContext from "../../hooks/commonContext.js";
import { getFormatedTime, FormatedDates } from "../../services/helpers.js";
import { getOneIssue } from "../../services/apiservices/issues.js";
import { DetailsColumns } from "../../app/IssueManagement/IssuesManageTableColumns.js";
import ViewAttachments from "../../app/IssueManagement/IssueDetails/ViewAttachments.jsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@mui/material";
import Header from "../header/header.jsx";
import { APP_DOMAINURL } from "../../services/config.js";

const useStyles = makeStyles((theme) => ({
    customTooltip: {
        position: "absolute",
        margin: "auto",
        top: "15%",
        left: "176.5px",
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        padding: '10px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 100,
        width: "195px",
    },
    tooltipArrow: {
        position: "absolute",
        margin: "auto",
        top: "30%",
        left: "162.5px",
        zIndex: 1000,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: 'none',
        borderBottomColor: '#ffffff',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
    },
    blockedStateWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        boxSizing: "border-box",
        minHeight: "calc(100vh - 133px)",
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    blockedPaper: {
        width: "100%",
        padding: theme.spacing(4),
        maxWidth: 640,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 16,
        border: "1px solid #d6e7df",
        borderTop: "5px solid #078037",
        boxShadow: "0 12px 32px rgba(7, 128, 55, 0.08)",
        background: "linear-gradient(180deg, #ffffff 0%, #f7fbf8 100%)",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(3),
            borderRadius: 12,
        },
    },
    blockedBadge: {
        display: "inline-flex",
        alignItems: "center",
        marginBottom: theme.spacing(2),
        padding: "6px 12px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        color: "#078037",
        backgroundColor: "#eaf5ef",
    },
    blockedTitle: {
        color: "#1f2a37",
        fontFamily: '"Raleway", "MarkOT", "Arial", sans-serif',
        fontSize: 30,
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: "-0.02em",
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down("sm")]: {
            fontSize: 24,
        },
    },
    blockedMessage: {
        color: "#52606d",
        fontFamily: '"Raleway", "MarkOT", "Arial", sans-serif',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: 1.75,
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            fontSize: 16,
        },
    },
    blockedHelper: {
        color: "#5f6c7b",
        fontFamily: '"Raleway", "MarkOT", "Arial", sans-serif',
        fontSize: 17,
        fontWeight: 500,
        lineHeight: 1.75,
        [theme.breakpoints.down("sm")]: {
            fontSize: 15,
        },
    },
    blockedLink: {
        color: "#0b6bcb",
        fontWeight: 700,
        textDecoration: "underline",
        display: "inline",
        opacity: 1,
    },
}));

const TooltipArrow = () => {
    return (
        <svg width="15" height="20" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
            <polygon points="10,0 0,5 10,10" fill="#fff" stroke="#555" strokeWidth={0.2} />
        </svg>
    );
};

const RecipientsTooltip = ({ styles }) => {
    return <div className={styles.customTooltip}>
        {"Please login to see details"}</div>;
};

const EscalateForm = ({ IssueDetail }) => {
    return (
        <div className="issueDetails mb-20 formtxtbtm">
            <h3 className="formtxt">Description</h3>
            <p>{IssueDetail?.description}</p>
            <ViewAttachments attachments={IssueDetail?.attachments} />
            <Divider fullWidth className="mt-10" />
        </div>
    );
};

function PublicIssuePage() {
    const { issueId } = useParams();
    const commonContext = useContext(CommonContext);
    const [issueDetail, setIssueDetail] = useState(null);
    const [showTooltip, setShowTooltip] = useState(null);
    const [accessBlocked, setAccessBlocked] = useState(false);
    const [blockedMessage, setBlockedMessage] = useState("");
    const [loadError, setLoadError] = useState("");
    const styles = useStyles();
    const isMobile = useMediaQuery('(max-width:768px)');

    const handleMouseOver = (responseItem) => {
        setShowTooltip(responseItem);
    };

    const handleMouseLeave = () => {
        setShowTooltip(null);
    };

    useEffect(() => {
        if (!issueId || issueId === "") return;

        setAccessBlocked(false);
        setBlockedMessage("");
        setLoadError("");
        setIssueDetail(null);

        commonContext?.setLoader(true);

        getOneIssue(
            issueId,
            (res) => {
                console.log("res", res)
                if (res?.publicAccessAllowed === false) {
                    setAccessBlocked(true);
                    setBlockedMessage(
                        res?.message ||
                        "Public viewing for this issue is not available."
                    );
                    setIssueDetail(null);
                    commonContext?.setLoader(false);
                    return;
                }
                if (!res || res.status !== true || !res.data) {
                    setIssueDetail(null);
                    setLoadError("Unable to load this issue.");
                    commonContext?.setLoader(false);
                    return;
                }

                const details = {
                    ...res.data,
                    issueId: `IS-${String(res.data?.issueNumber).padStart(4, '0')}`,
                    employeeName: res.data?.employee?.name,
                    clientName: res.data?.client?.name,
                    dateOfRequest: res.data?.dateOfRequest,
                    timeZone: "America/New_York",
                };

                let responses =
                    details?.responses &&
                    Object.keys(details.responses).map((key) => ({
                        ...details.responses[key],
                        id: key,
                    }));

                responses = responses
                    ? responses.sort((a, b) => (a.respondOn > b.respondOn ? 1 : -1))
                    : [];

                setIssueDetail({ ...details, responses });
                commonContext?.setLoader(false);
            },
            (resError) => {
                console.error("Error fetching issue details:", resError);
                const msg =
                    typeof resError?.error === "string"
                        ? resError.error
                        : resError?.error?.message || "Unable to load this issue.";
                setLoadError(msg);
                setIssueDetail(null);
                commonContext?.setLoader(false);
            }
        );
        // Intentionally depend only on issue id — context setLoader is stable.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [issueId]);

    const getEmailDisplay = (item) => {
        return <strong>{item.respondBy.name}</strong>;
    };

    const renderStateCard = ({ badge, title, message, helperText }) => (
        <Paper className={styles.blockedPaper} elevation={0}>
            <div className={styles.blockedBadge}>{badge}</div>
            <Typography variant="h5" className={styles.blockedTitle}>
                {title}
            </Typography>
            <Typography variant="body1" className={styles.blockedMessage}>
                {message}
            </Typography>
            <Typography variant="body2" className={styles.blockedHelper}>
                {helperText}
            </Typography>
        </Paper>
    );

    const blockedOrErrorContent = () => {
        if (accessBlocked) {
            return (
                renderStateCard({
                    badge: "Access Status",
                    title: "Public access unavailable",
                    message: blockedMessage,
                    helperText: (
                        <>
                            If you have an account, you can{" "}
                            <a href={APP_DOMAINURL} className={styles.blockedLink} style={{ color: "#0b6bcb" }}>
                                sign in to ProTeams
                            </a>{" "}
                            to view and respond to issues, or reply using the email thread you received.
                        </>
                    ),
                })
            );
        }
        if (loadError) {
            return (
                renderStateCard({
                    badge: "Link Status",
                    title: "Unable to open this page",
                    message: loadError,
                    helperText: (
                        <>
                            The link may be incorrect or expired. You can try{" "}
                            <a href={APP_DOMAINURL} className={styles.blockedLink} style={{ color: "#0b6bcb" }}>
                                signing in to ProTeams
                            </a>{" "}
                            if you have access.
                        </>
                    ),
                })
            );
        }
        return null;
    };

    return (
        <>
            <CssBaseline />
            <AppBar position="fixed" className={styles.appBar}>
                <Header />
            </AppBar>
            {(accessBlocked || loadError) ? (
                <div className={styles.blockedStateWrapper}>
                    {blockedOrErrorContent()}
                </div>
            ) : (
            <Container>
                {issueDetail && (
                    <span className="d-flex flex-justify-center color-danger fw-bold" style={isMobile ? { marginTop: "15px", marginLeft: "15px" } : { marginTop: "15px" }}>
                        This page is for viewing purposes only. To respond to the issue, please login or reply to the email you received.
                    </span>
                )}

                {issueDetail && (
                    <div className="sectionBox deissue1">
                        <ThemeTablen
                            rows={[issueDetail]}
                            headCells={DetailsColumns}
                            hidePagination
                        />
                        <EscalateForm IssueDetail={issueDetail} />
                        <div>
                            <div className="issueDetails">
                                {issueDetail?.responses?.sort((a, b) => b.respondOn - a.respondOn).map((responseItem, index) => (
                                    <div key={index} className="mb-15 responc">
                                        <Typography variant="subtitle1">
                                            <em>
                                                <div className="d-flex flex-space-between">
                                                    <span className="w-75">{getEmailDisplay(responseItem)}</span>
                                                    <span className="w-20">{FormatedDates(responseItem?.respondOn, issueDetail?.timeZone)} {getFormatedTime(responseItem?.respondOn, issueDetail?.timeZone)}</span>
                                                </div>
                                            </em>
                                        </Typography>
                                        <Typography variant="body1" className="pv-12">{responseItem?.description}</Typography>
                                        <div className="d-flex flex-space-between flex-end position-relative">
                                            <div className="issuelink" onMouseOver={() => handleMouseOver(responseItem)} onMouseLeave={handleMouseLeave}>
                                                Included Recipients
                                            </div>
                                            {showTooltip === responseItem && responseItem?.recipients?.length > 0 && (
                                                <>
                                                    <div className={styles.tooltipArrow}><TooltipArrow /></div>
                                                    <RecipientsTooltip styles={styles} />
                                                </>
                                            )}
                                            <ViewAttachments attachments={responseItem?.attachments} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </Container>
            )}
        </>
    );
}

export default PublicIssuePage;
